<template>
    <span v-click-outside="hide" class="headway-widget-selector pull-right hidden-print">
        <span class="anchor"><!-- This is a Icon we use --></span>
    </span>
</template>


<script>
    import uuid from 'uuid/v4'
    import ClickOutside from 'vue-click-outside'
    const HEADWAY_WIDGET_URL = '//cdn.headwayapp.co/widget.js'
    export default {
        data () {
            return {
                id: uuid(),
                widget: undefined,
                config: {
                    selector: '.headway-widget-selector',
                    account: 'J3XqWy',
                    callbacks: {
                        onWidgetReady: (widget) => { this.widget = widget },
                        onShowWidget: () => this.$parent.$emit('close:header-items', [this.id])
                    }
                }
            }
        },
        directives: {
            ClickOutside
        },
        methods: {
            hide () {
                if (this.widget) this.widget.hide()
            }
        },
        mounted () {
            let headwayScript = document.createElement('script')
            headwayScript.async = true
            headwayScript.setAttribute('src', HEADWAY_WIDGET_URL)
            document.head.appendChild(headwayScript)
            const waitForHeadway = () => {
                if (window['Headway']) {
                    window.Headway.init(this.config)
                } else {
                    setTimeout(() => waitForHeadway(), 100)
                }
            }
            waitForHeadway()
            this.$parent.$on('close:header-items', ([id]) => {
                if (this.id !== id) this.hide()
            })
        }
    }
</script>

<style>
    .pull-right {
        float: right;
    }
</style>
